import ExerciseGenerator from "./ExerciseGenerator";
import {getRandomIntegerWithRange/*, getRandomNumberWithRange*/} from "../Random";
import Exercise from "../Exercise";
import ResultItem from "../ResultItem";
import NumberSystems from "../NumberSystems";

export default class GradualMultiplicationExerciseGenerator extends ExerciseGenerator {
    generate = (decimalTask) => {
        /*
        Example
        Task: 0.9375
        0.9375 * 2 = 1.875  R 1 (R = Value before the comma)
        0.875  * 2 = 1.75   R 1 (If theres no value before the comma, R = 0)
        0.75   * 2 = 1.5    R 1
        0.5    * 2 = 1      R 1
         */

        if(!decimalTask) {
            //Copied from android app, prevents too long tasks (long means space in the UI)
            const presetValues = [0.5, 0.25, 0.125, 0.0625, 0.03125, 0.015625];
            //Result will always be divisible by 5 which prevents too long tasks
            decimalTask = 0.0;
            let changedValue = false;
            for (let i = 0; String(decimalTask).length < 6 && i < presetValues.length; i++) {
                const rnd = Math.random() >= 0.5;
                if (rnd) {
                    decimalTask += presetValues[i];
                    changedValue = true;
                }
            }
            // if still zero, select one of the values randomly
            // (no float comparisons to 0.0)
            if (! changedValue) {
                // 4 for the same reason as 6 on the for-loop before
                decimalTask = presetValues[getRandomIntegerWithRange(0,4)];
            }
        }

        //Prepare variable for division
        let resultValue = decimalTask;
        //Result[] will contain all results
        const result = [];
        //Iterate until 0
        while(resultValue > 0){
            //Multiply by 2
            resultValue = (resultValue * 2);

            result.push(new ResultItem(String(resultValue), NumberSystems.DECIMAL, true, true, true));

            if(resultValue >= 1){
                //If the value is larger than 1, add a 1 to the result
                result.push(new ResultItem(String(1), NumberSystems.BINARY, true, true));
                //also subtract 1 AFTER saving the current product to the result
                //Why after?
                //The user needs to enter the product of 0.9375 * 2 which is 1.875
                //If we subtract 1 and then add it, the correct answer in the UI would be 0.875
                //Which is actually the task for the next step
                resultValue = resultValue-1;
            }else{
                result.push(new ResultItem(String(0), NumberSystems.BINARY, true, true));
            }
        }
        return new Exercise([decimalTask], [String(decimalTask)], result);
    }

}